import { render, staticRenderFns } from "./notfound.vue?vue&type=template&id=26d4f0c3"
import script from "./notfound.vue?vue&type=script&lang=js"
export * from "./notfound.vue?vue&type=script&lang=js"
import style0 from "./notfound.vue?vue&type=style&index=0&id=26d4f0c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports